import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, QrCode, Truck, Package, CreditCard } from 'lucide-angular';

@Component({
  selector: 'app-hero-banner',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './hero-banner.component.html',
  styleUrl: './hero-banner.component.css'
})
export class HeroBannerComponent { }
